import { Vue, Options } from 'vue-class-component';

@Options({
  name: 'ListItemCheck',
  props: {
    modelValue: {
      type: Array,
      required: true,
    },
    name: {
      required: true,
      type: String,
    },
    inputId: {
      required: true,
      type: String,
    },
    label: {
      required: true,
      type: String,
    },
    value: {
      required: true,
    },
    last: {
      type: Boolean,
      default: false,
      required: false,
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  emits: ['update:modelValue','update:value'],
})
export default class CardRadio extends Vue {
  modelValue!: string[];
  name!: string;
  inputId!: string;
  value!: string;
  last!: boolean;
  label!: string;
  disabled!: boolean;
  get checked () {
    return this.modelValue.includes(this.value)
  }

  setValue() {
    if(this.disabled)return;
    if (this.checked){
      this.modelValue.splice(this.modelValue.indexOf(this.value), 1)
    }else{
      this.modelValue.push(this.value)
    }
    this.$emit('update:value', this.value);
    this.$emit('update:modelValue', this.modelValue);
  }
}
